export default function createSlotProps(styles = {}, classes = {}) {
	return (slot, defaultClassName, defaultStyle) => ({
		className: classes[slot] ?? defaultClassName,
		style: defaultStyle ? { ...defaultStyle, ...styles[slot] } : styles[slot],
	});
}
